<template>
  <div class="collapse-wrapper" :class="{ hide: isSingleShow }">
    <el-collapse v-model="activeName" class="no-border" @change="handleChange">
      <el-collapse-item
        v-for="(item, index) in collapseList"
        :key="index"
        :name="index"
      >
        <template slot="title">
          <div class="collapse-title">
            <div>
              <el-tag
                size="small"
                effect="plain"
                :type="index === 0 ? 'warning' : 'info'"
                class="m-r-6"
              >
                {{
                  index === collapseList.length - 1
                    ? '原公告'
                    : `第${getItemName(index)}发布`
                }}
              </el-tag>
              <span class="collapse-title__item">{{ collapseTitle }}</span>
            </div>
          </div>
        </template>
        <slot name="default" :item="item" :index="index"></slot>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import nzh from 'nzh/cn'

export default {
  name: 'CollapseWrapper',

  props: {
    // 折叠面板数组
    collapseList: {
      type: Array,
      required: true
    },

    // 默认展开的名称
    defaultActiveName: {
      type: [String, Number],
      default: 0
    },

    // 展开项的标题
    collapseTitle: {
      type: String,
      default: ''
    },

    // 是否隐藏单个collapse的tab收缩
    hideSingleTab: {
      type: Boolean,
      default: true
    },

    // 原公示或原公告名称
    originalName: {
      type: String,
      default: '原公示'
    }
  },

  data() {
    return {
      activeName: 0
    }
  },

  computed: {
    // 只有一条记录时候，是否隐藏tab收缩
    isSingleShow() {
      return this.hideSingleTab && this.collapseList.length === 1
    }
  },

  methods: {
    getItemName(index) {
      if (index + 1 === this.collapseList.length) {
        return this.originalName
      } else {
        return `${this.collapseList.length - index}次`
      }
    },

    handleChange(activeNames) {
      this.$emit('change', activeNames)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.collapse-wrapper {
  padding: 0 24px 24px;
  background-color: $white-background-color;
  ::v-deep .el-collapse {
    .el-collapse-item {
      border-bottom: 1px solid $dividing-color;
      &:last-child {
        margin-bottom: 0;
      }

      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }

    &.no-border {
      border: none;

      .el-collapse-item {
        .el-collapse-item__header {
          &:last-child {
            border: none;
          }
        }

        .el-collapse-item__wrap {
          &:last-child {
            border: none;
          }
        }
      }
    }
  }
}

.hide {
  ::v-deep div[role='tab'] {
    display: none;
  }

  padding: 0px;
}

.collapse-title {
  display: flex;
  align-items: center;
  flex: 1 0 90%;
  justify-content: space-between;
  order: 1;
  .collapse-title__item {
    font-size: 14px;
  }
}
::v-deep {
  .el-collapse-item__header {
    flex: 1 0 auto;
  }
}
</style>
